import {
  resourceHubActions
} from './resourceHub.types';
export class ResourceActions {
  /**
   * updates the resources in the Resource Hub
   * @param content
   */
   static updateAllResources(content: any) {
    return {
      type: resourceHubActions.UPDATE_ALL_RESOURCES,
      payload: content
    };
  }

  /**
   * updates the selected resource content when a resource is selected 
   * @param content
   */
  static updateResource(content: any) {
    return {
      type: resourceHubActions.UPDATE_RESOURCE,
      payload: content
    };
  }
}